<template>
  <div class="page-break">
    <div class="flex flex-wrap gap-2 items-center mb-4">
      <h5><i class="dot"></i>합동안전점검 결과 주요 지적사항</h5>
      <div v-if="!readonly && !isPrint" class="ml-auto flex items-center justify-center">
        <vs-button color="secondary" @click="handleAddRow">항목 추가</vs-button>
        <vs-button color="secondary" type="border" :disabled="disabledDeleteBtn" class="ml-4" @click="handleRemoveRow">선택 항목 삭제</vs-button>
      </div>
    </div>

    <table v-for="(item, item_i) in list" :key="`list-${item_i}`" class="page-break mb-3">
      <colgroup>
        <col v-if="!readonly && !isPrint" width="40" />
        <col />
      </colgroup>
      <thead>
        <tr>
          <th v-if="!readonly && !isPrint" class="p-0">
            <vs-checkbox v-if="checkData[item_i]" :value="checkData[item_i].length === item.childs.length && 0 < item.childs.length" class="custom-checkbox justify-center mx-0" @click.native="() => onClickAllCheckbox(item_i)" />
          </th>
          <th colspan="2">
            <div class="flex items-center flex-wrap gap-2">
              <div class="flex-1 flex items-center gap-2">
                <p>Point</p>
                <div v-if="isPrint" class="print-input" style="min-width: 435px">{{ item.point }}</div>
                <ml-input v-else class="w-full" :readonly="readonly" v-model="item.point" />
              </div>
              <div v-if="!readonly && !isPrint" class="ml-auto flex items-center justify-center gap-2">
                <vs-button color="secondary" @click="() => handleChildAddRow(item_i)">행 추가</vs-button>
                <vs-button v-if="checkData[item_i]" color="secondary" type="border" :disabled="checkData[item_i].length < 1 || checkData[item_i].length === 0" @click="() => handleChildRemoveRow(item_i)">선택 행 삭제</vs-button>
              </div>
            </div>
          </th>
        </tr>
      </thead>

      <!-- ================================= CHILDS ============================== -->
      <tbody>
        <tr v-for="(child, child_i) in item.childs" :key="`child-${item_i}_${child_i}`">
          <td v-if="!readonly && !isPrint"><vs-checkbox v-model="checkData[item_i]" :vs-value="child_i" class="custom-checkbox justify-center mx-0" /></td>
          <td v-for="_t in ['지적사항', '조치사항']" :key="`child-${item_i}_${child_i}_${_t}`">
            <p class="title">{{ _t }}</p>
            <FileUploader :readonly="readonly || isPrint" type="only-image" class="file-input" placeholder="파일업로드" v-model="child[_t].img" />
            <div class="flex items-center gap-3 mt-2">
              <p>장소</p>
              <div v-if="isPrint" class="print-input">{{ child[_t].장소 }}</div>
              <ml-input v-else :readonly="readonly" v-model="child[_t].장소" class="flex-1" />
            </div>
            <div class="flex items-center gap-3 mt-2">
              <p>내용</p>
              <div v-if="isPrint" class="print-input">{{ child[_t].내용 }}</div>
              <ml-input v-else :readonly="readonly" v-model="child[_t].내용" class="flex-1" />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import FileUploader from "@/components/FileUploader.vue";

export default {
  components: { FileUploader },
  props: {
    isPrint: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      list: this.value,
      checkData: Array.from({ length: this.value.length }, () => []),
    };
  },
  computed: {
    disabledDeleteBtn() {
      const isCheck = this.checkData.reduce((prev, curr, index) => {
        return prev && (curr.length < 1 || this.list[index].childs.length !== curr.length);
      }, true);
      return this.list.length < 1 || isCheck;
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        this.list = value;
      },
    },
    list: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    if (this.list.length < 1) {
      this.handleAddRow();
    }
  },
  methods: {
    // All 체크박스 클릭
    onClickAllCheckbox(index) {
      if (this.checkData[index].length === this.list[index].childs.length) {
        this.$set(this.checkData, index, []);
      } else {
        this.$set(
          this.checkData,
          index,
          this.list[index].childs.map((_, _i) => _i)
        );
      }
    },
    // 항목추가
    handleAddRow() {
      this.checkData.push([]);

      const addData = {
        point: "",
        childs: [
          {
            지적사항: { img: "", 장소: "", 내용: "" },
            조치사항: { img: "", 장소: "", 내용: "" },
          },
        ],
      };
      this.list.push(addData);
    },
    // 선택삭제
    handleRemoveRow() {
      // 전체항목이 선택되어 있는 항목의 index를 찾는다.
      const fData = [];
      this.list.map((item, item_i) => {
        if (this.checkData[item_i].length === item.childs.length) fData.push(item_i);
      });
      // 선택한 항목을 제외한 새로운 리스트를 생성한다.
      const newList = this.list.filter((_, index) => !fData.includes(index));

      // Data set
      this.$set(
        this,
        "checkData",
        newList.map((_) => [])
      );
      this.$set(this, "list", newList);

      if (this.list.length < 1) this.handleAddRow();
    },

    // Child 항목추가
    handleChildAddRow(index) {
      const addData = {
        지적사항: { img: "", 장소: "", 내용: "" },
        조치사항: { img: "", 장소: "", 내용: "" },
      };
      this.list[index].childs.push(addData);
    },
    // Child 선택삭제
    handleChildRemoveRow(index) {
      // 선택한 항목을 제외한 새로운 리스트를 생성한다.
      const newList = this.list[index].childs.filter((_, _i) => !this.checkData[index].includes(_i));

      // Data set
      this.$set(this.checkData, index, []);
      this.$set(this.list[index], "childs", newList);

      if (this.list[index].childs < 1) this.handleChildAddRow(index);
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  &,
  th,
  td {
    font-size: 14px;
    font-weight: 500;
    border: solid 1px #cdcdcd;
  }

  th {
    background: #f9f9f9;
    padding: 14px;
  }

  td {
    padding: 8px;
  }
}

.custom-checkbox::v-deep {
  .vs-checkbox {
    margin: 0 !important;
  }
}

.title {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 8px;
}

::v-deep .only-image {
  height: 290px !important;
  background-color: white !important;
}

@media print {
  .page-break {
    page-break-inside: avoid;
    page-break-after: auto;
  }
}
</style>
